import { ApiResponse } from '@type/api'
import { axiosDirect } from '@utils/axios'

export const checkEmail = async (email: string) => {
  if (!email) {
    return false
  }

  try {
    const { data: response } = await axiosDirect.post<ApiResponse<any>>('/auth/check-email', {
      email: email,
    })

    return response?.data?.status === 'ok'
  } catch (e) {
    return true
  }
}
